import { render, staticRenderFns } from "./PageBuilderComponent.vue?vue&type=template&id=443eae56&"
import script from "./PageBuilderComponent.vue?vue&type=script&lang=js&"
export * from "./PageBuilderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports